var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.projID && _vm.proj)?_c('div',[(_vm.proj.service_level == 'lite')?_c('div',[_c('ProjectSummaryLite')],1):_c('div',[_c('ProjectSummary')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }